/**
 * DOTA2 Localization data.
 */
export * from './languages';
export { default as dota } from './dota';
//# sourceMappingURL=index.js.map